// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sFl7d","rootNoMargin":"styles_rootNoMargin__JMSYk"};